import Immutable from 'immutable';
// types
import CatalogTypes from '~/constants/types/CatalogTypes';
import {types as ComplementsTypes} from '~/actions/ComplementsActions';
import {types as CompatibleStylesTypes} from '~/actions/CompatibleStylesActions';

export function initialState() {
  return Immutable.Map({
    styles: Immutable.Map(),
    complements: Immutable.Map(),
    alternatives: Immutable.Map(),
    compatibleStyles: Immutable.Map(),
    fetching: Immutable.Set(),
    fetchingComplements: Immutable.Map(),
    catalogCID: '',
    catalogCIDProductColorId: ''
  });
}

export default function catalog(state = initialState(), action) {
  switch (action.type) {
    case CatalogTypes.FETCH_STYLE: {
      const styleId = action.payload;
      return state.setIn(['styles', styleId], {isFetching: true, errors: []});
    }
    case CatalogTypes.STYLE_LOADED: {
      const {style} = action.payload;
      return state.setIn(['styles', style.id], style);
    }
    case CatalogTypes.STYLE_LOAD_ERROR: {
      const {styleId, error} = action.payload;
      return state.updateIn(['styles', styleId], style => {
        style.errors.push(error);
        style.isFetching = false;
        return style;
      });
    }
    case CatalogTypes.FETCH_STYLES: {
      const styleIds = action.payload;
      return state.update('fetching', fetching =>
        styleIds.reduce((f, id) => f.add(id), fetching)
      );
    }
    case CatalogTypes.SET_OVERLAY_STYLES: {
      const styleIds = action.payload;
      return state.setIn(['overlayStyles'], styleIds);
    }
    case CatalogTypes.STYLES_SUCCESS: {
      const fetchedStyles = action.payload;
      return state
        .update('styles', styles =>
          styles.withMutations(styles => {
            return fetchedStyles.forEach(
              style => (styles = styles.set(style.id, style))
            );
          })
        )
        .update('fetching', fetching =>
          fetchedStyles.reduce((f, s) => f.remove(s.id), fetching)
        );
    }
    case CatalogTypes.STYLES_ERROR: {
      const {styleIds, error} = action.payload;
      return state
        .update('styles', styles =>
          styleIds?.reduce(
            (acc, styleId) =>
              styles.updateIn(['styles', styleId], style => {
                const nextStyle = style || {};
                nextStyle.errors = [error];
                return nextStyle;
              }),
            styles
          )
        )
        .update('fetching', fetching =>
          styleIds.reduce((f, s) => f.remove(s), fetching)
        );
    }
    case CatalogTypes.LOAD_CATALOG_DESIGN: {
      const {catalogCID, catalogCIDProductColorId} = action.payload;
      return state
        .set('catalogCID', catalogCID)
        .set('catalogCIDProductColorId', catalogCIDProductColorId);
    }
    case ComplementsTypes.FETCH: {
      const styleId = action.payload;
      return state
        .setIn(['complements', styleId], undefined)
        .setIn(['alternatives', styleId], undefined);
    }
    case ComplementsTypes.SET_IS_FETCHING: {
      const {styleId, fetching} = action.payload;
      return state.setIn(['fetchingComplements', styleId], {
        isFetching: fetching
      });
    }
    case ComplementsTypes.FETCH_SUCCESS: {
      const {complements, styleId, alternatives} = action.payload;
      return state
        .setIn(['complements', styleId], Immutable.List(complements))
        .setIn(['alternatives', styleId], Immutable.List(alternatives));
    }
    case ComplementsTypes.FETCH_ERROR: {
      const {styleId} = action.payload;
      return state.setIn(['complements', styleId], Immutable.List());
    }
    case ComplementsTypes.ALTERNATIVES_FETCH_SUCCESS: {
      return state.setIn(
        ['alternatives', action.payload.styleId],
        Immutable.List(action.payload.alternativeIds)
      );
    }
    case CompatibleStylesTypes.FETCH: {
      const styleId = action.payload;
      return state.setIn(['compatibleStyles', styleId], Immutable.List());
    }
    case CompatibleStylesTypes.FETCH_SUCCESS: {
      const {compatibleStyles, styleId} = action.payload;
      return state.setIn(
        ['compatibleStyles', styleId],
        Immutable.List(compatibleStyles)
      );
    }
    case CompatibleStylesTypes.FETCH_ERROR: {
      const {styleId} = action.payload;
      return state.setIn(['compatibleStyles', styleId], Immutable.List());
    }
    default:
      return state;
  }
}
